/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 38f4a4bd0071b2694a9c532d37cf8cc6 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StandaloneScooterQuickEstimatesQueryVariables = {};
export type StandaloneScooterQuickEstimatesQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ScooterQuickEstimatesForm_viewer">;
    };
};
export type StandaloneScooterQuickEstimatesQuery = {
    readonly response: StandaloneScooterQuickEstimatesQueryResponse;
    readonly variables: StandaloneScooterQuickEstimatesQueryVariables;
};



/*
query StandaloneScooterQuickEstimatesQuery {
  viewer {
    ...ScooterQuickEstimatesForm_viewer
  }
}

fragment ScooterQuickEstimatesForm_viewer on Viewer {
  currentUser {
    fullName
    id
  }
}
*/

const node: ConcreteRequest = {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "StandaloneScooterQuickEstimatesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ScooterQuickEstimatesForm_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "StandaloneScooterQuickEstimatesQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "fullName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "StandaloneScooterQuickEstimatesQuery",
    "id": null,
    "text": "query StandaloneScooterQuickEstimatesQuery {\n  viewer {\n    ...ScooterQuickEstimatesForm_viewer\n  }\n}\n\nfragment ScooterQuickEstimatesForm_viewer on Viewer {\n  currentUser {\n    fullName\n    id\n  }\n}\n",
    "metadata": {}
  }
};
(node as any).hash = '313b0e7b075cadaa00fb0b219c1b2c2d';
export default node;
